import styled from "styled-components";
import {WheelOfJackpotbetLogoDefaultBox} from "./wheel-of-jb-logo.default.box";

export const WheelOfJackpotbetLogoCasino777Box = styled(WheelOfJackpotbetLogoDefaultBox)`
    height: 10rem;
    width: 19rem;  
    
    transform: translate(10%, -30%);
    background-repeat: no-repeat;
`;